<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'VerifyPolicy',

    metaInfo: { title: 'Verify Policy' },

    extends: View,

    mixins: [
      LoadSections([
        'verify-policy',
        'info',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'verifypolicy',
      },
    },
  }
</script>
